export default __webpack_public_path__ + "static/media/blue_right_arr.841a3929.svg";